// extracted by mini-css-extract-plugin
export default {"headerInputs":"HeaderInputs_headerInputs__avAve","inputGroup":"HeaderInputs_inputGroup__8L0Zv","titleInput":"HeaderInputs_titleInput__NZ+gk"};